import { getLoginAccountId, getLoginShopid, getWebId } from '@RootCommon/utils'
import { commonRequest, commonRequestAll } from '../utils/request'

export const reportEvent = async (url: string, params = {}) => {
  try {
    return commonRequest.post(
      url,
      {
        appInfo: await getAppInfo(),
        ...params,
      },
      {
        autoToast: false,
      },
    )
  } catch (e) {
    // @ts-ignore
  }
}

export const reportEventAll = async (url: string, params = {}) =>
  commonRequestAll.post(
    url,
    {
      appInfo: await getAppInfo(),
      ...params,
    },
    {
      autoToast: false,
    },
  )

const getAppInfo = async () => ({
  shopId: getLoginShopid(),
  accountId: getLoginAccountId(),
  uuid: getWebId(),
  ver: await window.top.electronAPI?.getVersion(),
})
